import React, { useState, useEffect, useCallback } from 'react';
import SectionHeader from './SectionHeader';
import './Playground.css';

function Playground() {
    const [open, setOpen] = useState(false);

    const close = useCallback(() => setOpen(false), []);

    useEffect(() => {
        if (!open) return undefined;

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        const onKeyDown = (e) => {
            if (e.key === 'Escape') close();
        };
        const onMessage = (e) => {
            if (e.data?.type === 'close-playground') close();
        };

        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('message', onMessage);
        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('message', onMessage);
        };
    }, [open, close]);

    return (
        <>
            <SectionHeader index="08" label="Recess" title="The playground" />
            <div className="playground-body reveal">
                <p className="playground-lede">
                    A portfolio you can walk around. And jump on.
                </p>
                <p className="playground-text">
                    A hand-inked island assembles itself in front of you: a lighthouse
                    sweeping its beam, a radar dish pulsing, a vinyl deck spinning off
                    music notes, paper planes circling overhead. Walk with WASD, jump
                    with space (a joystick and jump button appear on phones), and hunt
                    down all seven ink drops hidden between the landmarks · finish the
                    collection and the island celebrates. Built with Three.js, toon-shaded
                    and ink-outlined, in the same paper and vermilion as this page.
                </p>
                <div className="playground-actions">
                    <button
                        type="button"
                        className="btn-doc btn-doc--accent"
                        onClick={() => setOpen(true)}
                    >
                        Enter the playground
                    </button>
                    <span className="mono-label playground-note">
                        Opens on this page · desktop &amp; mobile · Esc to return
                    </span>
                </div>
            </div>

            {open && (
                <div
                    className="playground-overlay"
                    role="dialog"
                    aria-modal="true"
                    aria-label="Interactive playground"
                >
                    <iframe
                        className="playground-frame"
                        src="/play/index.html?embed=1"
                        title="Playground — walkable island"
                        allow="fullscreen"
                    />
                </div>
            )}
        </>
    );
}

export default Playground;
